import React from 'react';

const TermsAndConditions = () => {

  return (
    <div className="terms-and-conditions">
      <p>
        View the {' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.homedepot.com/c/Path_to_Pro_Network_Terms_and_Conditions"
          data-testid="terms-and-conditions"
        >
          Terms & Conditions {' '}
        </a>
        for the Path to Pro Network
      </p>
    </div>
  );
};

export default TermsAndConditions;
